import { Radio } from 'antd'
import { observer } from 'mobx-react-lite'
import React from 'react'
import type { FieldMethods } from '../types'

/**
 * Пропси для Radio компонента
 */
export interface RadioInputProps {
    /** Поле форми з методами bind/setValue */
    field?: FieldMethods
    /** Індекс для множинних полів */
    index?: number
    /** Чи заблоковано поле */
    disabled?: boolean
    /** CSS клас */
    className?: string
    /** Inline стилі */
    style?: React.CSSProperties
    /** Додаткові пропси */
    [key: string]: any
}

/**
 * Radio Input компонент для форм
 * Використовується для одиночних радіо-кнопок
 * 
 * @example
 * ```tsx
 * <FormField name="isActive" type={FieldType.RADIO} />
 * ```
 */
export const RadioInput: React.FC<RadioInputProps> = observer(({ field, index }) => {
    if (!field) {
        return null
    }

    return <Radio {...field.bind({ index: index ?? 0 })} />
})
